import { render, staticRenderFns } from "./PageNavi.vue?vue&type=template&id=5e52b96c&"
import script from "./PageNavi.vue?vue&type=script&lang=js&"
export * from "./PageNavi.vue?vue&type=script&lang=js&"
import style0 from "./PageNavi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports